export enum USER_SHIFT_TYPE {
  SELECT_SHIFT = 'SELECT_SHIFT',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT'
}
